const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const calculateNumberOfDays = (dateFrom, dateTo) => {
    if (!dateFrom || !dateTo) return 1;

    const from = new Date(dateFrom);
    const to = new Date(dateTo);

    if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return 1;

    const days = Math.round((to.getTime() - from.getTime()) / MS_PER_DAY) + 1;

    return days > 0 ? days : 1;
};

export const isValidDateRange = (dateFrom, dateTo) => {
    if (!dateFrom || !dateTo) return true;

    const from = new Date(dateFrom);
    const to = new Date(dateTo);

    if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return false;

    return to.getTime() >= from.getTime();
};

export const calculateCategoryAddOn = (selectedCategories, { numberOfDays = 1, getUnitPrice }) => {
    return (selectedCategories ?? []).reduce((sum, cat) => {
        const unitPrice = getUnitPrice(cat);
        const multiplier = cat.price_calculation_method === 'per_person_per_day' ? numberOfDays : 1;
        return sum + (unitPrice * multiplier);
    }, 0);
};
